<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M5.5 2.5C3.84315 2.5 2.5 3.84315 2.5 5.5V19.5C2.5 21.1569 3.84315 22.5 5.5 22.5H19.5C21.1569 22.5 22.5 21.1569 22.5 19.5V5.5C22.5 3.84315 21.1569 2.5 19.5 2.5H5.5ZM8.16218 20.2959C8.45296 20.2959 8.68867 20.0602 8.68867 19.7695V10.3746C8.68867 10.0839 8.45296 9.84814 8.16218 9.84814H5.92102C5.63024 9.84814 5.39453 10.0839 5.39453 10.3746V19.7695C5.39453 20.0602 5.63024 20.2959 5.92102 20.2959H8.16218ZM7.04317 8.96232C5.86731 8.96232 4.91406 8.00908 4.91406 6.83321C4.91406 5.65735 5.86731 4.7041 7.04317 4.7041C8.21904 4.7041 9.17228 5.65735 9.17228 6.83321C9.17228 8.00908 8.21909 8.96232 7.04317 8.96232ZM19.9181 20.2959C20.1854 20.2959 20.4022 20.0791 20.4022 19.8118V15.2649V15.2313C20.4023 13.2477 20.4025 9.69043 16.5733 9.69043C14.8343 9.69043 14.0175 10.327 13.468 11.1518V10.3322C13.468 10.0648 13.2512 9.84807 12.9839 9.84807H10.6579C10.3906 9.84807 10.1738 10.0648 10.1738 10.3322V19.8118C10.1738 20.0791 10.3906 20.2959 10.6579 20.2959H12.9839C13.2513 20.2959 13.468 20.0791 13.468 19.8118V14.7291C13.5283 14.0462 13.829 12.5244 15.3111 12.5244C17.0811 12.5244 17.0461 14.4322 17.0313 15.2358C17.0301 15.2997 17.0291 15.3567 17.0291 15.4051V19.8118C17.0291 20.0791 17.2458 20.2959 17.5131 20.2959H19.9181Z"
				:fill="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgLinkedin',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
